export default __webpack_public_path__ + "static/media/Nathanael.5a40e129.png";